import { serviceMaker, methods, api } from "@/http/index.js";

export const getSuppliers = () =>
  serviceMaker(`/suppliers`, methods.GET, api.NGB);
export const createSupplier = (data) =>
  serviceMaker(`/suppliers`, methods.POST, api.NGB, data);
export const editSupplier = (id, data) =>
  serviceMaker(`/suppliers/${id}`, methods.PUT, api.NGB, data);
export const getSupplierById = (id) =>
  serviceMaker(`/suppliers/${id}`, methods.GET, api.NGB);
export const deleteSupplier = (id) =>
  serviceMaker(`/suppliers/${id}`, methods.DELETE, api.NGB);